import PropTypes from 'prop-types';

export const sys = PropTypes.shape({
  id: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
});

export const assetPropType = PropTypes.shape({
  sys: sys.isRequired,
  title: PropTypes.string.isRequired,
  file: PropTypes.shape({
    fileName: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
});

export const linkPropType = PropTypes.shape({
  label: PropTypes.string,
  url: PropTypes.string,
});

export const footerLinksPropType = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
  })
);

export const locationPropType = PropTypes.shape({
  lat: PropTypes.number,
  lon: PropTypes.number,
});

export const slotPropType = PropTypes.shape({
  start: PropTypes.string,
  end: PropTypes.string,
  isActive: PropTypes.bool,
});

const ticketsPropType = PropTypes.shape({
  types: PropTypes.shape({
    adult: PropTypes.shape({ price: PropTypes.string }),
    child: PropTypes.shape({ price: PropTypes.string }),
    infant: PropTypes.shape({ price: PropTypes.string }),
  }),
});

export const experiencePropType = PropTypes.shape({
  name: PropTypes.string,
  slug: PropTypes.string,
  market: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  heroGallery: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object)]),
  testimonials: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.object)]),
  address: PropTypes.string,
  tickets: ticketsPropType,
  location: locationPropType,
});

export const marketPropType = PropTypes.shape({
  name: PropTypes.string,
  slug: PropTypes.string,
  timeZone: PropTypes.string,
  featuredExperiences: PropTypes.arrayOf(PropTypes.string),
});
